import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

function SectionExtra() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="map" className="sectionExtra">
        <div className={`count1 count ${isVisible ? "visible" : ""}`}>
          <p className="number">11</p>
          <p className="text">{t("lp3_stat1_text")}</p>
        </div>
        <div className={`count2 count ${isVisible ? "visible" : ""}`}>
          <p className="text">{t("lp3_stat2_text")}</p>
          <p className="number">100.000m²</p>
        </div>
        <div className={`count3 count ${isVisible ? "visible" : ""}`}>
          <p className="number">27.000</p>
          <p className="text">{t("lp3_stat3_text")}</p>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default SectionExtra;
